"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelect = MultiSelect;
var _core = require("@blueprintjs/core");
var _select = require("@blueprintjs/select");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _colors = require("../../common/colors");
var _position = require("../../common/position");
var _IconButton = require("../button/IconButton");
var _iconNames = require("../icon/iconNames");
var _InternalIcon = require("../icon/InternalIcon");
var _Spinner = require("../spinner/Spinner");
var _typography = require("../typography/typography");
var _excluded = ["className", "disabled", "fill", "handleChange", "onQueryChange", "loading", "intent", "items", "usePortal", "allowCreateNewItems", "placeholder", "query", "resetQueryOnBlur", "selectedItems", "condensed", "tagRenderer"];
/* eslint-disable react/no-unused-prop-types */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var defaultTagRenderer = function defaultTagRenderer(item) {
  return item.label;
};
var itemPredicate = function itemPredicate(query, item, _index, exactMatch) {
  var normalizedLabel = item.label.toLowerCase();
  var normalizedQuery = query.toLowerCase();
  if (exactMatch) {
    return normalizedLabel === normalizedQuery;
  }
  return "".concat(normalizedLabel).indexOf(normalizedQuery) >= 0;
};
function MultiSelect(_ref) {
  var _multiSelectProps$tag, _multiSelectProps$tag2;
  var className = _ref.className,
    disabled = _ref.disabled,
    fill = _ref.fill,
    handleChange = _ref.handleChange,
    parentOnQueryChange = _ref.onQueryChange,
    loading = _ref.loading,
    intent = _ref.intent,
    items = _ref.items,
    usePortal = _ref.usePortal,
    allowCreateNewItems = _ref.allowCreateNewItems,
    placeholder = _ref.placeholder,
    query = _ref.query,
    _ref$resetQueryOnBlur = _ref.resetQueryOnBlur,
    resetQueryOnBlur = _ref$resetQueryOnBlur === void 0 ? true : _ref$resetQueryOnBlur,
    selectedItems = _ref.selectedItems,
    condensed = _ref.condensed,
    tagRenderer = _ref.tagRenderer,
    multiSelectProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(selectedItems || []),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    internalSelectedItems = _React$useState2[0],
    setInternalSelectedItems = _React$useState2[1];

  /**
   * We need to maintain the state of the query in this wrapper component
   * This is because we've added extra functionality to allow clearing the query when the select is blurred
   */
  var _React$useState3 = React.useState(query || ''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    internalQuery = _React$useState4[0],
    setInternalQuery = _React$useState4[1];
  var hasControlledQuery = query !== undefined;

  /**
   * This is some weird magic concocted by the Australian Enigma, Timothy Bruce Krins
   * Its purpose is to stop a popover flash from appearing when we reset the query. This flash happens even if the popover is closed!
   *
   * Internally Blueprint has this logic:
   * private handleQueryChange = (query: string, evt?: React.ChangeEvent<HTMLInputElement>) => {
   *  this.setState({ isOpen: query.length > 0 || (this.props.customTarget == null && !this.props.openOnKeyDown) });
   *  this.props.onQueryChange?.(query, evt);
   * };
   *
   * We don't why this causes it to open briefly, but in Tim's own words:
   * "Something about customTarget has been added, I'm not sure why handleQueryChange would change the isOpen state by default, but it does"
   *
   * The "fix" is to manipulate the `openOnKeyDown` prop by listening to focus and blur events on the input
   */
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    preventPopupFlash = _React$useState6[0],
    setPreventPopupFlash = _React$useState6[1];

  // Maintain internal query state on receiving new query prop
  React.useEffect(function () {
    if (hasControlledQuery) {
      setInternalQuery(query);
    } else {
      setInternalQuery('');
    }
  }, [query, hasControlledQuery]);
  var handleQueryChange = function handleQueryChange(newQuery) {
    if (parentOnQueryChange) parentOnQueryChange(newQuery);
    if (!hasControlledQuery) setInternalQuery(newQuery);
  };

  // Maintain internal internal items state on receiving new selectedItems prop
  React.useEffect(function () {
    if (selectedItems) setInternalSelectedItems(selectedItems);
  }, [selectedItems]);
  var handleItems = function handleItems(newItems) {
    setInternalSelectedItems(function () {
      if (handleChange) handleChange(newItems);
      return newItems;
    });
  };
  function handleClear() {
    handleItems([]);
  }
  var itemRenderer = function itemRenderer(item, _ref2) {
    var modifiers = _ref2.modifiers,
      handleClick = _ref2.handleClick,
      index = _ref2.index;
    if (!modifiers.matchesPredicate) return null;
    var isSelected = isItemSelected(item);

    /**
     * This is a bit of a last minute fudge but means that we can essentially get away with
     * providing richer content in our MenuItem without having to get developers to
     * supply a custom `itemRenderer`
     */
    var textWithCaption = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_typography.Body, null, item.label), /*#__PURE__*/React.createElement(_typography.Caption, {
      style: {
        marginTop: '4px'
      }
    }, item.caption));
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      active: modifiers.active,
      disabled: modifiers.disabled,
      icon: /*#__PURE__*/React.createElement(_InternalIcon.CheckboxIcon, {
        fill: isSelected ? _colors.Colors.SAGE_50 : _colors.Colors.GREY_50,
        style: {
          fill: isSelected ? _colors.Colors.SAGE_50 : _colors.Colors.GREY_50
        },
        icon: isSelected ? _InternalIcon.CheckboxIconNames.CHECKED : _InternalIcon.CheckboxIconNames.UNCHECKED
      }),
      onClick: handleClick,
      key: "".concat(item.value, "_").concat(index),
      text: item.caption ? textWithCaption : item.label,
      textClassName: isSelected ? _classes.Classes.ACTIVE : undefined,
      shouldDismissPopover: false
    });
  };
  function isItemSelected(item) {
    return internalSelectedItems.includes(item);
  }
  function deselectItem(item) {
    handleItems(internalSelectedItems.filter(function (i) {
      return i !== item;
    }));
  }
  var handleItemSelect = function handleItemSelect(item) {
    if (isItemSelected(item)) {
      deselectItem(item);
    } else {
      handleItems([item].concat(_toConsumableArray(internalSelectedItems)));
    }
  };
  var handleTagRemove = function handleTagRemove(label, index) {
    var item = internalSelectedItems.find(function (selectedItem, selectedItemIndex) {
      return selectedItemIndex === index && selectedItem.label === label;
    });
    deselectItem(item);
  };
  var handleFocus = React.useCallback(function () {
    setPreventPopupFlash(false);
  }, []);
  var handleBlur = React.useCallback(function () {
    setPreventPopupFlash(true);
  }, []);
  var createNewItemFromQuery = function createNewItemFromQuery(query) {
    // (TimKrins) I know I am allowed to return null here so just let me do it please thanks
    if (query.length < 2) return null;
    return {
      label: query,
      value: query
    };
  };
  var createNewItemRenderer = function createNewItemRenderer(query, active, handleClick) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      active: active,
      disabled: false,
      onClick: handleClick,
      text: "Create '".concat(query, "'"),
      shouldDismissPopover: false
    });
  };
  var noResults = /*#__PURE__*/React.createElement(_core.MenuItem, {
    disabled: true,
    text: allowCreateNewItems ? 'Type to add option...' : 'No results.'
  });

  /**
   * It's important that we don't use a portal if we're nested
   * within a Dialog. Refer to the `usePortal` docs.
   * @see https://blueprintjs.com/docs/#core/components/dialog
   */
  var turbolinksFixPortalDocumentBody = document.body;
  var popoverProps = _objectSpread(_objectSpread({}, multiSelectProps.popoverProps), {}, {
    fill: fill,
    minimal: true,
    modifiers: {
      offset: {
        enabled: true,
        offset: '0, 8'
      }
    },
    position: _position.Position.BOTTOM_LEFT,
    portalContainer: turbolinksFixPortalDocumentBody,
    usePortal: usePortal !== undefined ? usePortal : true,
    onClosed: function onClosed(node) {
      var _multiSelectProps$pop;
      if ((_multiSelectProps$pop = multiSelectProps.popoverProps) !== null && _multiSelectProps$pop !== void 0 && _multiSelectProps$pop.onClosed) multiSelectProps.popoverProps.onClosed(node);
      if (resetQueryOnBlur && !hasControlledQuery) {
        setInternalQuery('');
      }
    },
    transitionDuration: 0
  });
  var hasSelectedItems = internalSelectedItems.length > 0;
  var condensedPlaceholder = internalSelectedItems.length === 1 ? '1 item' : "".concat(internalSelectedItems.length, " items");

  /**
   * For condensed multi selects we need to make sure we add a condensed class when we've got selected items
   * Not necessarily the best name but indicates that the placeholder text should be a darker colour
   *
   * For the tagInputClass - yes its horrible but I need to be able to pass through classes like Classes.FORCE_HOVER
   * for use in the stories
   */
  var tagInputClass = (multiSelectProps === null || multiSelectProps === void 0 || (_multiSelectProps$tag = multiSelectProps.tagInputProps) === null || _multiSelectProps$tag === void 0 ? void 0 : _multiSelectProps$tag.className) || '';
  var baseTagInputProps = _objectSpread(_objectSpread({
    disabled: disabled,
    intent: intent
  }, multiSelectProps.tagInputProps), {}, {
    onRemove: handleTagRemove,
    tagProps: (multiSelectProps === null || multiSelectProps === void 0 || (_multiSelectProps$tag2 = multiSelectProps.tagInputProps) === null || _multiSelectProps$tag2 === void 0 ? void 0 : _multiSelectProps$tag2.tagProps) || {
      round: true
    },
    className: (0, _classnames.default)(_defineProperty({}, _classes.Classes.CONDENSED, condensed && hasSelectedItems), _defineProperty({}, tagInputClass, tagInputClass)),
    inputProps: {
      onFocus: handleFocus,
      onBlur: handleBlur
    }
  });

  /**
   * Loading spinner always takes precedence as a right element
   * If condensed and we have selected items then ensure we add a button to clear the select box easily
   */
  var tagInputProps;
  if (loading) {
    tagInputProps = _objectSpread(_objectSpread({}, baseTagInputProps), {}, {
      rightElement: /*#__PURE__*/React.createElement(_Spinner.Spinner, {
        small: true
      })
    });
  } else if (condensed && hasSelectedItems) {
    tagInputProps = _objectSpread(_objectSpread({}, baseTagInputProps), {}, {
      rightElement: /*#__PURE__*/React.createElement(_IconButton.IconButton24, {
        icon: _iconNames.IconNames8.CROSS,
        onClick: handleClear
      })
    });
  } else {
    tagInputProps = baseTagInputProps;
  }
  var classes = (0, _classnames.default)(_defineProperty({}, _classes.Classes.intentClass(intent), intent), _defineProperty({}, _classes.Classes.ACTIVE, condensed && hasSelectedItems), className);
  return /*#__PURE__*/React.createElement(_select.MultiSelect, _extends({
    className: classes
  }, multiSelectProps, {
    items: items,
    itemPredicate: itemPredicate,
    itemRenderer: itemRenderer,
    onQueryChange: handleQueryChange,
    popoverProps: popoverProps,
    query: internalQuery,
    tagInputProps: tagInputProps,
    tagRenderer: condensed ? function () {
      return null;
    } : tagRenderer || defaultTagRenderer,
    createNewItemRenderer: createNewItemRenderer,
    noResults: noResults,
    placeholder: condensed && hasSelectedItems ? condensedPlaceholder : placeholder,
    selectedItems: internalSelectedItems,
    createNewItemFromQuery: allowCreateNewItems ? createNewItemFromQuery : undefined,
    onItemSelect: handleItemSelect,
    openOnKeyDown: preventPopupFlash
  }));
}